// extracted by mini-css-extract-plugin
module.exports = {"clearfix":"notice-ticker_clearfix_1PJC3"};